
// import React, { useEffect, useState } from 'react';
// import {
//   Box, Paper, Typography, FormControl, InputLabel, Select, MenuItem,
//   Table, TableHead, TableBody, TableRow, TableCell, Checkbox, Button
// } from '@mui/material';
// import axios from './AxiosInstance';

// function JobStatusTable() {
//   const [deviceId, setDeviceId] = useState('');
//   const [devices, setDevices] = useState([]);
//   const [jobStatus, setJobStatus] = useState([]);
//   const [serverResponse, setServerResponse] = useState({ message: '', error: '' });
//   const [deviceLoadMessage, setDeviceLoadMessage] = useState('');
//   const [loadingJobIds, setLoadingJobIds] = useState(new Set());
//   const [editingRow, setEditingRow] = useState(null);

//   useEffect(() => {
//     axios.get('/recent2')
//       .then(res => {
//         if (res.data && res.data.length > 0) {
//           setDevices(res.data);
//           setDeviceLoadMessage('');
//         } else {
//           setDevices([]);
//           setDeviceLoadMessage('No devices available.');
//         }
//       })
//       .catch(() => {
//         setDevices([]);
//         setDeviceLoadMessage('Failed to load devices.');
//       });
//   }, []);

//   useEffect(() => {
//     if (deviceId) {
//       axios.get(`/job-status/${deviceId}`)
//         .then(res => {
//           const uniqueRows = [];
//           const seenKeys = new Set();
//           res.data.forEach(row => {
//             const key = `${row.job_id}-${row.device_id}`;
//             if (!seenKeys.has(key)) {
//               seenKeys.add(key);
//               uniqueRows.push(row);
//             }
//           });
//           setJobStatus(uniqueRows);
//           setServerResponse({ message: '', error: '' });
//         })
//         .catch(() => {
//           setJobStatus([]);
//           setServerResponse({ message: '', error: 'Failed to load job status.' });
//         });
//     } else {
//       setJobStatus([]);
//       setServerResponse({ message: '', error: '' });
//     }
//   }, [deviceId]);

//   const handleCancelChange = async (job_id, device_id, value) => {
//     const loadingKey = `${job_id}-${device_id}`;
//     import React, { useEffect, useState } from 'react';
//     import {
//       Box, Paper, Typography, FormControl, InputLabel, Select, MenuItem,
//       Table, TableHead, TableBody, TableRow, TableCell, Checkbox, Button
//     } from '@mui/material';
//     import axios from './AxiosInstance';
    
//     function JobStatusTable() {
//       const [deviceId, setDeviceId] = useState('');
//       const [devices, setDevices] = useState([]);
//       const [jobStatus, setJobStatus] = useState([]);
//       const [serverResponse, setServerResponse] = useState({ message: '', error: '' });
//       const [deviceLoadMessage, setDeviceLoadMessage] = useState('');
//       const [loadingJobIds, setLoadingJobIds] = useState(new Set());
//       const [editingRow, setEditingRow] = useState(null);
    
//       useEffect(() => {
//         axios.get('/recent2')
//           .then(res => {
//             if (res.data && res.data.length > 0) {
//               setDevices(res.data);
//               setDeviceLoadMessage('');
//             } else {
//               setDevices([]);
//               setDeviceLoadMessage('No devices available.');
//             }
//           })
//           .catch(() => {
//             setDevices([]);
//             setDeviceLoadMessage('Failed to load devices.');
//           });
//       }, []);
    
//       useEffect(() => {
//         if (deviceId) {
//           axios.get(`/job-status/${deviceId}`)
//             .then(res => {
//               const uniqueRows = [];
//               const seenKeys = new Set();
//               res.data.forEach(row => {
//                 const key = `${row.job_id}-${row.device_id}`;
//                 if (!seenKeys.has(key)) {
//                   seenKeys.add(key);
//                   uniqueRows.push(row);
//                 }
//               });
//               setJobStatus(uniqueRows);
//               setServerResponse({ message: '', error: '' });
//             })
//             .catch(() => {
//               setJobStatus([]);
//               setServerResponse({ message: '', error: 'Failed to load job status.' });
//             });
//         } else {
//           setJobStatus([]);
//           setServerResponse({ message: '', error: '' });
//         }
//       }, [deviceId]);
    
//       const handleCancelChange = async (job_id, device_id, value) => {
//         const loadingKey = `${job_id}-${device_id}`;
//         setLoadingJobIds(prev => new Set(prev).add(loadingKey));
    
//         try {
//           await axios.post('/update-job-cancel', {
//             updates: [{ device_id: parseInt(device_id), cancel: value }]
//           });
    
//           setServerResponse({ message: 'Cancel status updated successfully.', error: '' });
    
//           const res = await axios.get(`/job-status/${deviceId}`);
//           const uniqueRows = [];
//           const seenKeys = new Set();
//           res.data.forEach(row => {
//             const key = `${row.job_id}-${row.device_id}`;
//             if (!seenKeys.has(key)) {
//               seenKeys.add(key);
//               uniqueRows.push(row);
//             }
//           });
//           setJobStatus(uniqueRows);
//         } catch {
//           setServerResponse({ message: '', error: 'Failed to update cancel status.' });
//         } finally {
//           setLoadingJobIds(prev => {
//             const newSet = new Set(prev);
//             newSet.delete(loadingKey);
//             return newSet;
//           });
//           setEditingRow(null);
//         }
//       };
    
//       const DEVICE_STATUS_MAP = {
//         1: 'In Progress',
//         2: 'Failed',
//         3: 'Success'
//       };
    
//       const CLOUD_STATUS_MAP = {
//         0: 'Queued',
//         1: 'Issued',
//         2: 'Finished'
//       };
    
//       return (
//         <Paper elevation={3} sx={{ p: 4, mt: 4, maxWidth: 1000, mx: 'auto' }}>
//           <Typography variant="h5" gutterBottom>
//             Job Status Viewer
//           </Typography>
    
//           {deviceLoadMessage ? (
//             <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
//               {deviceLoadMessage}
//             </Typography>
//           ) : (
//             <FormControl fullWidth margin="normal">
//               <InputLabel id="device-select-label">Select Device</InputLabel>
//               <Select
//                 labelId="device-select-label"
//                 value={deviceId}
//                 label="Select Device"
//                 onChange={(e) => setDeviceId(e.target.value)}
//               >
//                 {devices.map((dev) => (
//                   <MenuItem key={`device-${dev.job_id}`} value={dev.job_id}>
//                     {dev.descr}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           )}
    
//           {jobStatus.length > 0 && (
//             <Table size="small" sx={{ mt: 3 }}>
//               <TableHead>
//                 <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
//                   <TableCell>Job ID</TableCell>
//                   <TableCell>Device NAME</TableCell>
//                   <TableCell>Cloud Status</TableCell>
//                   <TableCell>Device Status</TableCell>
//                   <TableCell>Start Time</TableCell>
//                   <TableCell>End Time</TableCell>
//                   <TableCell>Result</TableCell>
//                   <TableCell>Cancel</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {jobStatus.map((row) => {
//                   const rowKey = `job-${row.job_id}-dev-${row.device_id}`;
//                   const isInProgress = row.device_status === 1;
//                   const loadingKey = `${row.job_id}-${row.device_id}`;
//                   const isEditing = editingRow === rowKey;
    
//                   return (
//                     <TableRow key={rowKey} hover>
//                       <TableCell>{row.job_id}</TableCell>
//                       <TableCell>{row.device_name}</TableCell>
//                       <TableCell>{CLOUD_STATUS_MAP[row.cloud_status] || 'Unknown'}</TableCell>
//                       <TableCell>{DEVICE_STATUS_MAP[row.device_status] || 'Unknown'}</TableCell>
//                       <TableCell>{row.start_ts}</TableCell>
//                       <TableCell>{row.end_ts}</TableCell>
//                       <TableCell sx={{ maxWidth: 150, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
//                         {JSON.stringify(row.result)}
//                       </TableCell>
//                       <TableCell>
//                         <Checkbox
//                           checked={row.cancel}
//                           disabled={!isInProgress}
//                           onChange={() => {
//                             if (isInProgress) {
//                               setEditingRow(isEditing ? null : rowKey);
//                             }
//                           }}
//                           color="primary"
//                         />
//                         {isInProgress && isEditing && (
//                           <Box sx={{ display: 'flex', flexDirection: 'column', mt: 1 }}>
//                             {!row.cancel ? (
//                               <Button
//                                 size="small"
//                                 variant="contained"
//                                 color="success"
//                                 onClick={() => handleCancelChange(row.job_id, row.device_id, true)}
//                                 disabled={loadingJobIds.has(loadingKey)}
//                                 sx={{ mb: 1 }}
//                               >
//                                 Enable
//                               </Button>
//                             ) : (
//                               <Button
//                                 size="small"
//                                 variant="outlined"
//                                 color="error"
//                                 onClick={() => handleCancelChange(row.job_id, row.device_id, false)}
//                                 disabled={loadingJobIds.has(loadingKey)}
//                               >
//                                 Cancel
//                               </Button>
//                             )}
//                           </Box>
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })}
//               </TableBody>
//             </Table>
//           )}
    
//           {deviceId && jobStatus.length === 0 && !serverResponse.error && (
//             <Typography sx={{ mt: 2 }} color="text.secondary" align="center">
//               No job status found for the selected device.
//             </Typography>
//           )}
    
//           {serverResponse.error ? (
//             <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
//               {serverResponse.error}
//             </Typography>
//           ) : (
//             serverResponse.message && (
//               <Typography
//                 color="success.main"
//                 sx={{ mt: 2, textAlign: 'center', fontSize: '1.25rem', fontWeight: 'bold' }}
//               >
//                 {serverResponse.message}
//               </Typography>
//             )
//           )}
//         </Paper>
//       );
//     }
    
//     export default JobStatusTable;
//     setLoadingJobIds(prev => new Set(prev).add(loadingKey));

//     try {
//       await axios.post('/update-job-cancel', {
//         updates: [{ device_id: parseInt(device_id), cancel: value }]
//       });

//       setServerResponse({ message: 'Cancel status updated successfully.', error: '' });

//       const res = await axios.get(`/job-status/${deviceId}`);
//       const uniqueRows = [];
//       const seenKeys = new Set();
//       res.data.forEach(row => {
//         const key = `${row.job_id}-${row.device_id}`;
//         if (!seenKeys.has(key)) {
//           seenKeys.add(key);
//           uniqueRows.push(row);
//         }
//       });
//       setJobStatus(uniqueRows);
//     } catch {
//       setServerResponse({ message: '', error: 'Failed to update cancel status.' });
//     } finally {
//       setLoadingJobIds(prev => {
//         const newSet = new Set(prev);
//         newSet.delete(loadingKey);
//         return newSet;
//       });
//       setEditingRow(null);
//     }
//   };

//   const DEVICE_STATUS_MAP = {
//     1: 'In Progress',
//     2: 'Failed',
//     3: 'Success'
//   };

//   const CLOUD_STATUS_MAP = {
//     0: 'Queued',
//     1: 'Issued',
//     2: 'Finished'
//   };

//   return (
//     <Paper elevation={3} sx={{ p: 4, mt: 4, maxWidth: 1000, mx: 'auto' }}>
//       <Typography variant="h5" gutterBottom>
//         Job Status Viewer
//       </Typography>

//       {deviceLoadMessage ? (
//         <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
//           {deviceLoadMessage}
//         </Typography>
//       ) : (
//         <FormControl fullWidth margin="normal">
//           <InputLabel id="device-select-label">Select Device</InputLabel>
//           <Select
//             labelId="device-select-label"
//             value={deviceId}
//             label="Select Device"
//             onChange={(e) => setDeviceId(e.target.value)}
//           >
//             {devices.map((dev) => (
//               <MenuItem key={`device-${dev.job_id}`} value={dev.job_id}>
//                 {dev.descr}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       )}

//       {jobStatus.length > 0 && (
//         <Table size="small" sx={{ mt: 3 }}>
//           <TableHead>
//             <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
//               <TableCell>Job ID</TableCell>
//               <TableCell>Device NAME</TableCell>
//               <TableCell>Cloud Status</TableCell>
//               <TableCell>Device Status</TableCell>
//               <TableCell>Start Time</TableCell>
//               <TableCell>End Time</TableCell>
//               <TableCell>Result</TableCell>
//               <TableCell>Cancel</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {jobStatus.map((row) => {
//               const rowKey = `job-${row.job_id}-dev-${row.device_id}`;
//               const isInProgress = row.device_status === 1;
//               const loadingKey = `${row.job_id}-${row.device_id}`;
//               const isEditing = editingRow === rowKey;

//               return (
//                 <TableRow key={rowKey} hover>
//                   <TableCell>{row.job_id}</TableCell>
//                   <TableCell>{row.device_name}</TableCell>
//                   <TableCell>{CLOUD_STATUS_MAP[row.cloud_status] || 'Unknown'}</TableCell>
//                   <TableCell>{DEVICE_STATUS_MAP[row.device_status] || 'Unknown'}</TableCell>
//                   <TableCell>{row.start_ts}</TableCell>
//                   <TableCell>{row.end_ts}</TableCell>
//                   <TableCell sx={{ maxWidth: 150, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
//                     {JSON.stringify(row.result)}
//                   </TableCell>
//                   <TableCell>
//                     <Checkbox
//                       checked={row.cancel}
//                       disabled={!isInProgress}
//                       onChange={() => {
//                         if (isInProgress) {
//                           setEditingRow(isEditing ? null : rowKey);
//                         }
//                       }}
//                       color="primary"
//                     />
//                     {isInProgress && isEditing && (
//                       <Box sx={{ display: 'flex', flexDirection: 'column', mt: 1 }}>
//                         {!row.cancel ? (
//                           <Button
//                             size="small"
//                             variant="contained"
//                             color="success"
//                             onClick={() => handleCancelChange(row.job_id, row.device_id, true)}
//                             disabled={loadingJobIds.has(loadingKey)}
//                             sx={{ mb: 1 }}
//                           >
//                             Enable
//                           </Button>
//                         ) : (
//                           <Button
//                             size="small"
//                             variant="outlined"
//                             color="error"
//                             onClick={() => handleCancelChange(row.job_id, row.device_id, false)}
//                             disabled={loadingJobIds.has(loadingKey)}
//                           >
//                             Cancel
//                           </Button>
//                         )}
//                       </Box>
//                     )}
//                   </TableCell>
//                 </TableRow>
//               );
//             })}
//           </TableBody>
//         </Table>
//       )}

//       {deviceId && jobStatus.length === 0 && !serverResponse.error && (
//         <Typography sx={{ mt: 2 }} color="text.secondary" align="center">
//           No job status found for the selected device.
//         </Typography>
//       )}

//       {serverResponse.error ? (
//         <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
//           {serverResponse.error}
//         </Typography>
//       ) : (
//         serverResponse.message && (
//           <Typography
//             color="success.main"
//             sx={{ mt: 2, textAlign: 'center', fontSize: '1.25rem', fontWeight: 'bold' }}
//           >
//             {serverResponse.message}
//           </Typography>
//         )
//       )}
//     </Paper>
//   );
// }

// export default JobStatusTable;
import React, { useEffect, useState } from 'react';
import {
   Paper, Typography, FormControl, InputLabel, Select, MenuItem,
  Table, TableHead, TableBody, TableRow, TableCell, Checkbox,
  Dialog, DialogTitle, DialogContent, DialogActions, Button
} from '@mui/material';
import axios from './AxiosInstance';

function JobStatusTable() {
  const [deviceId, setDeviceId] = useState('');
  const [devices, setDevices] = useState([]);
  const [jobStatus, setJobStatus] = useState([]);
  const [serverResponse, setServerResponse] = useState({ message: '', error: '' });
  const [deviceLoadMessage, setDeviceLoadMessage] = useState('');
  const [loadingJobIds, setLoadingJobIds] = useState(new Set());

  // For MUI Confirm Dialog
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null); // { job_id, device_id }

  useEffect(() => {
    axios.get('/api/recent2')
      .then(res => {
        if (res.data && res.data.length > 0) {
          setDevices(res.data);
          setDeviceLoadMessage('');
        } else {
          setDevices([]);
          setDeviceLoadMessage('No devices available.');
        }
      })
      .catch(() => {
        setDevices([]);
        setDeviceLoadMessage('Failed to load devices.');
      });
  }, []);

  useEffect(() => {
    if (deviceId) {
      axios.get(`/api/job-status/${deviceId}`)
        .then(res => {
          const uniqueRows = [];
          const seenKeys = new Set();
          res.data.forEach(row => {
            const key = `${row.job_id}-${row.device_id}`;
            if (!seenKeys.has(key)) {
              seenKeys.add(key);
              uniqueRows.push(row);
            }
          });
          setJobStatus(uniqueRows);
          setServerResponse({ message: '', error: '' });
        })
        .catch(() => {
          setJobStatus([]);
          setServerResponse({ message: '', error: 'Failed to load job status.' });
        });
    } else {
      setJobStatus([]);
      setServerResponse({ message: '', error: '' });
    }
  }, [deviceId]);

  const handleCancelChange = async (job_id, device_id, value) => {
    const loadingKey = `${job_id}-${device_id}`;
    setLoadingJobIds(prev => new Set(prev).add(loadingKey));

    try {
      await axios.post('/api/update-job-cancel', {
        updates: [{ device_id: parseInt(device_id), cancel: value }]
      });

      setServerResponse({ message: 'Cancel status updated successfully.', error: '' });

      const res = await axios.get(`/api/job-status/${deviceId}`);
      const uniqueRows = [];
      const seenKeys = new Set();
      res.data.forEach(row => {
        const key = `${row.job_id}-${row.device_id}`;
        if (!seenKeys.has(key)) {
          seenKeys.add(key);
          uniqueRows.push(row);
        }
      });
      setJobStatus(uniqueRows);
    } catch {
      setServerResponse({ message: '', error: 'Failed to update cancel status.' });
    } finally {
      setLoadingJobIds(prev => {
        const newSet = new Set(prev);
        newSet.delete(loadingKey);
        return newSet;
      });
    }
  };

  const DEVICE_STATUS_MAP = {
    1: 'In Progress',
    2: 'Failed',
    3: 'Success'
  };

  const CLOUD_STATUS_MAP = {
    0: 'Queued',
    1: 'Issued',
    2: 'Finished'
  };

  const openConfirm = (job) => {
    setSelectedJob(job);
    setConfirmOpen(true);
  };

  const closeConfirm = () => {
    setConfirmOpen(false);
    setSelectedJob(null);
  };

  const confirmCancel = async () => {
    if (selectedJob) {
      await handleCancelChange(selectedJob.job_id, selectedJob.device_id, true);
      closeConfirm();
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, mt: 4, maxWidth: 1000, mx: 'auto' }}>
      <Typography variant="h5" gutterBottom>
        Job Status Viewer
      </Typography>

      {deviceLoadMessage ? (
        <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
          {deviceLoadMessage}
        </Typography>
      ) : (
        <FormControl fullWidth margin="normal">
          <InputLabel id="device-select-label">Select Job description </InputLabel>
          <Select
            labelId="device-select-label"
            value={deviceId}
            label="Select Device"
            onChange={(e) => setDeviceId(e.target.value)}
          >
            {devices.map((dev) => (
              <MenuItem key={`device-${dev.job_id}`} value={dev.job_id}>
                {dev.descr}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {jobStatus.length > 0 && (
        <Table size="small" sx={{ mt: 3 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell>Job ID</TableCell>
              <TableCell>Device NAME</TableCell>
              <TableCell>Cloud Status</TableCell>
              <TableCell>Device Status</TableCell>
              <TableCell>Start Time</TableCell>
              <TableCell>End Time</TableCell>
              <TableCell>Result</TableCell>
              <TableCell>Cancel</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {jobStatus.map((row) => {
              const rowKey = `job-${row.job_id}-dev-${row.device_id}`;
              const isInProgress = row.device_status === 1;

              return (
                <TableRow key={rowKey} hover>
                  <TableCell>{row.job_id}</TableCell>
                  <TableCell>{row.device_name}</TableCell>
                  <TableCell>{CLOUD_STATUS_MAP[row.cloud_status] || 'Unknown'}</TableCell>
                  <TableCell>{DEVICE_STATUS_MAP[row.device_status] || 'Unknown'}</TableCell>
                  <TableCell>{row.start_ts}</TableCell>
                  <TableCell>{row.end_ts}</TableCell>
                  <TableCell sx={{ maxWidth: 150, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                    {JSON.stringify(row.result)}
                  </TableCell>
                  <TableCell>
                    <Checkbox
                      checked={row.cancel}
                      disabled={!isInProgress || row.cancel}
                      onChange={() => {
                        if (!row.cancel) {
                          openConfirm({ job_id: row.job_id, device_id: row.device_id });
                        }
                      }}
                      color="primary"
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}

      {deviceId && jobStatus.length === 0 && !serverResponse.error && (
        <Typography sx={{ mt: 2 }} color="text.secondary" align="center">
          No job status found for the selected device.
        </Typography>
      )}

      {serverResponse.error ? (
        <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
          {serverResponse.error}
        </Typography>
      ) : (
        serverResponse.message && (
          <Typography
            color="success.main"
            sx={{ mt: 2, textAlign: 'center', fontSize: '1.25rem', fontWeight: 'bold' }}
          >
            {serverResponse.message}
          </Typography>
        )
      )}

      {/* MUI Confirm Dialog */}
      <Dialog open={confirmOpen} onClose={closeConfirm}>
        <DialogTitle>Confirm Cancel</DialogTitle>
        <DialogContent>
          <Typography>Are you sure want to cancel this job?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirm} color="inherit">No</Button>
          <Button onClick={confirmCancel} variant="contained" color="error">Yes, Cancel</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}

export default JobStatusTable;
